<template>
  <div class="container bg-light col-12">
    <div class="row justify-content-center bg-light">
      <div class="">
        <h1 class="font-weight-light text-center">Dashboard</h1>
        <h6 class="text-center text-secondary">
          Check out the latest customizable videos! Personalize yours today!
        </h6>
      </div>
    </div>
    <div class="row col-12 text-center dashvideos justify-content-center">
      <div class="source-videos" v-for="item in srcVideos" :key="item.id">
        <b-button title="Personalize Video" @click.prevent="setSrcVid(item.id)">
          <div class="col-sm">
            <span>
              <div fluid="sm" class="thumb">
                <img class="row" :src="item.thumbnail" fluid />
              </div>
              <div class="secret">
                <font-awesome-icon icon="edit"></font-awesome-icon>
              </div>
            </span>
            <h6>{{ item.videoTitle }}</h6>
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
  name: "Dashboard",
  data: function() {
    return {
      videoTitle: null,
      uid: this.$store.state.user.uid,
    };
  },
  mounted() {
    this.$root.$emit("bv::hide::popover");
  },
  components: {
    FontAwesomeIcon,
  },
  computed: {
    srcVid: {
      get() {
        return this.$store.state.customization.srcVid;
      },
      set(id) {
        this.$store.commit("setSrcVid", id);
      },
    },
    srcVideos: {
      get() {
        return this.$store.state.srcVideos;
      },
    },
  },
  methods: {
    handleAdd: function() {
      this.$emit("addVideo", this.videoTitle);
      this.videoTitle = null;
      this.$refs.videoTitle.focus();
    },
    setSrcVid: function(id) {
      this.srcVid = id;
      this.$router.push({ path: "/personalize" });
    },
  },
};
</script>
